// This file is part of Invenio-RDM-Records
// Copyright (C) 2020-2023 CERN.
// Copyright (C) 2020-2022 Northwestern University.
//
// Invenio-RDM-Records is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

import _cloneDeep from "lodash/cloneDeep";
import _get from "lodash/get";
import _pick from "lodash/pick";
import _set from "lodash/set";
import { Field } from "./Field";

export class TemporalCoverageField extends Field {
  constructor({ fieldpath, schema, deserializedDefault = [], serializedDefault = [] }) {
    super({ fieldpath, deserializedDefault, serializedDefault });
    this.schema = schema;
    this.schemaKeys = Object.keys(this.schema);
  }

  deserialize(serialized, defaultLocale) {
    const fieldValues = _get(serialized, this.fieldpath, this.deserializedDefault);

    const deserializedElements = fieldValues
      .map((value, i) => {
        if (value.spans) {
          return { spans: value.spans, __key: i, type: "spans" };
        } else if (value.ranges) {
          let deserializedRange = _pick(
            value.ranges,
            Object.keys(this.schema.ranges.schema)
          );

          Object.keys(this.schema.ranges.schema).forEach((key) => {
            deserializedRange[key] = this.schema.ranges.schema[key].deserialize(
              deserializedRange[key],
              defaultLocale
            );
          });

          return { ranges: deserializedRange, __key: i, type: "ranges" };
        }

        return null;
      })
      .filter(Boolean); // Remove null values

    return _set(_cloneDeep(serialized), this.fieldpath, deserializedElements);
  }

  serialize(deserialized, defaultLocale) {
    const fieldValues = _get(deserialized, this.fieldpath, this.serializedDefault);

    const serializedElements = fieldValues
      .map((value) => {
        if (value.spans) {
          return { spans: value.spans };
        } else if (value.ranges) {
          let serializedRange = _pick(
            value.ranges,
            Object.keys(this.schema.ranges.schema)
          );

          Object.keys(this.schema.ranges.schema).forEach((key) => {
            serializedRange[key] = this.schema.ranges.schema[key].serialize(
              serializedRange[key],
              defaultLocale
            );
          });

          return { ranges: serializedRange };
        }

        return null;
      })
      .filter(Boolean); // Remove null values

    return _set(_cloneDeep(deserialized), this.fieldpath, serializedElements);
  }
}
